module.exports = __webpack_public_path__ + "img/kt-zf.edb7d0fb.png";